<template>
  <div>
    <slot name="trigger" />

    <b-modal
      v-model="isOpen"
      :width="600"
      @close="closeModal"
    >
      <div class="modal-card">
        <header class="modal-card-head is-flex-direction-column is-flex is-align-items-flex-start">
          <div
            class="is-flex is-full is-align-content-space-between"
            style="width: 100%"
          >
            <p class="modal-card-title title mb-2">
              {{ $t("modal_status_update_in_property_list") }}
            </p>
            <button
              class="delete"
              aria-label="close"
              @click="closeModal"
            />
          </div>
          <div class="modal-card-subtitle">
            <p class="is-size-7">
              {{ $t("modal_message_first_part") }}
              {{ $shortStreet(property.address.address_1) }}
              {{ property.address.address_2 }}
              ({{ property.address.city }})
              {{ $t("modal_message_second_part") }}
              <span
                v-if="currentStatus"
                class="has-text-weight-bold"
              >
                {{ $t(currentStatus.type) }}
              </span>
              <span v-if="newStatus">
                {{ $t("modal_message_third_part") }}
                {{ $t("from") }}
                <span class="has-text-weight-bold">
                  {{ $t(newStatus) }}
                </span>
                {{ $t("to") }}
                <span class="has-text-weight-bold">
                  {{ $t(newStatus) }}
                </span>
                {{ $t("modal_message_forth_part") }}
              </span>
            </p>
          </div>
        </header>
        <section class="modal-card-body">
          <v-popup-form
            :property="property"
            @success="onSuccess"
            @close="closeModal"
            @status="onUpdatePropertyStatus"
          />
        </section>
      </div>
    </b-modal>
  </div>
</template>


<script>
import form_popup from "../_form_popup.vue";

export default {
  components: {
    "v-popup-form": form_popup,
  },
  props: {
    property: {
      default: null,
      type: Object,
    },
    isShown: {
      default: false,
      type: Boolean,
    },
    currentStatus: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      newStatus: null,
      isOpen: this.isShown,
    };
  },
  watch: {
    isShown: {
      handler(newValues, oldValues) {
        this.isOpen = newValues;
      },
      deep: true
    }
  },
  methods: {
    onUpdatePropertyStatus(status) {
      this.newStatus = status;
    },
    onSuccess(response) {
      this.newStatus = null;
      this.$emit("success", response.data.propertyStatus);
    },
    closeModal() {
      this.newStatus = null;
      this.$emit("close", null);
    },
  },
};
</script>
